import * as React from "react";
import ConnectedThemeProvider from "@configuratorware/configurator-frontendgui/App/Screens/Configurator/ThemeProvider";
import merge from "lodash/merge";
import { createTheme } from "@material-ui/core";

const customTheme = createTheme({
  palette: {
    primary: { main: "#000" },
  },
  typography: {
    fontFamily: "KlavikaWebBasic, Roboto, Helvetica, sans-serif",
  },
});

const overrideTheme = (theme) => {
  merge(theme.overrides, {
    MuiPaper: {
      rounded: {
        borderRadius: "0 !important",
      },
    },
    MuiButton: {
      root: {
        borderRadius: "0 !important",
      },
      label: {
        textTransform: "initial",
      },
    },
    // @ts-ignore
    PrivateNotchedOutline: {
      root: {
        borderRadius: 0,
      },
    },
    SaveConfiguration: {
      successResult: {
        borderRadius: 0,
      },
    },
    DesignAreaControlbox: {
      colorAmountMessage: {
        borderRadius: 0,
      },
    },
    CustomDialog: {
      MuiDialogBorder: {
        maxWidth: 720,
      },
    },
    MuiDialogTitle: {
      root: {
        paddingLeft: "32px !important",
        paddingRight: "32px !important",
      },
    },
    MuiDialogContent: {
      root: {
        paddingLeft: "32px !important",
        paddingRight: "32px !important",
      },
    },
    MuiDialogActions: {
      root: {
        paddingLeft: "32px !important",
        paddingRight: "32px !important",
        paddingBottom: "16px !important",
      },
    },
    Option: {
      price: {
        display: "none",
      },
      text: {
        width: "auto",
      },
    },
    OptionsList: {
      dialogStyle: {
        [theme.breakpoints.down("xl")]: {
          width: 360,
        },
      },
    },
    "Designer-CanvasContainer": {
      canvasContainer: {
        backgroundColor: "rgba(255,255,255,0.5)",
        "& canvas": {
          backgroundColor: "transparent",
        },
      },
    },
  });
};

export default ({ children }) => (
  <ConnectedThemeProvider customTheme={customTheme} withTheme={overrideTheme}>
    {children}
  </ConnectedThemeProvider>
);
